module.exports = __webpack_public_path__ + "img/passcode.4c093116.svg";